import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'product-list',
  name: '商品列表',
  icon: '品',
  group: '业务组件',
  description: '读取商品数据并渲染客户端商品卡片',
  defaultProps: {
    title: '推荐商品',
    limit: 12
  }
}
